import styles from "./Dashboard.module.css";
import { Button, SpeedDial, Fab, NavigationIcon, Skeleton } from "@mui/material";
import Icon from "@mdi/react";
import { mdiCommentTextOutline } from "@mdi/js";

// charts
import {
	Chart as ChartJS,
	ArcElement,
	Tooltip,
	Legend,
	Title,
	CategoryScale,
	LinearScale,
	BarElement,
	PointElement,
	LineElement,
} from "chart.js";
import { Doughnut, Bar, Line } from "react-chartjs-2";

// React
import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";

// services
import Services from "tools/Services";

// context
import { useContext } from "react";
import { MyContext } from "components/RoleContext";
import { Role } from "tools/Enums";

// components
import Loader from "components/Loader";

ChartJS.register(ArcElement, Tooltip, Legend, Title, CategoryScale, LinearScale, BarElement, PointElement, LineElement);

export default function Home() {
	const { role, setRole } = useContext(MyContext);
	const [loading, setLoading] = useState(true);
	const [allCharts, setAllCharts] = useState([]);

	useEffect(() => {
		loadAllCharts();
	}, []);

	const loadAllCharts = async () => {
		// GET
		let res = await Services.get("/Dashboard/getAllCharts");

		// ERROR
		if (res.status !== 200) {
			console.error(res);
			return;
		}

		// SUCCESS
		setAllCharts(res.data);
		setLoading(false);
	};

	const MyDoughnutChart = ({ chart }) => {
		//total number: TODO in the backend?
		let totalNb = chart.data.reduce((partialSum, a) => partialSum + a, 0);
		// needed to put text inside a doughnut
		let plugins = [
			{
				beforeDraw: function (c) {
					var width = c.width,
						height = c.height,
						ctx = c.ctx;
					ctx.restore();
					var fontSize = height / 110;
					ctx.font = fontSize + "em sans-serif";
					ctx.textBaseline = "top";
					ctx.fillStyle = "grey";
					var text = "" + totalNb,
						textX = Math.round((width - ctx.measureText(text).width) / 2),
						textY = height / 2;
					ctx.fillText(text, textX, textY);
					ctx.save();
				},
			},
		];
		let backgroundColor;
		let borderColor;
		let position;
		let displayLegend;
		switch (chart.title) {
			case "Roadmap":
				backgroundColor = ["rgba(190, 240, 255, 0.5)", "rgba(255, 227, 151,0.5)", "rgba(188, 226, 195,0.5)"];
				borderColor = ["rgba(0, 195, 255,1)", "rgba(211, 144, 0,1)", "rgba(68, 158, 88,1)"];
				position = "bottom";
				displayLegend = false;
				break;
			case "Feature Requests":
				backgroundColor = ["rgba(236, 236, 236,0.5)", "rgba(197, 197, 197,0.5)", "rgba(230, 203, 203,0.5)"];
				borderColor = ["rgba(163, 163, 163,1)", "rgba(90, 90, 90,1)", "rgba(184, 66, 66,1)"];
				position = "bottom";
				displayLegend = false;
				break;
			default:
				backgroundColor = [
					"#63b598",
					"#ce7d78",
					"#ea9e70",
					"#a48a9e",
					"#c6e1e8",
					"#648177",
					"#6b2e5f",
					"#64820f",
					"#9cb64a",
					"#996c48",
					"#9ab9b7",
					"#06e052",
					"#e3a481",
					"#0eb621",
					"#fc458e",
					"#b2db15",
					"#aa226d",
					"#792ed8",
					"#73872a",
					"#520d3a",
					"#cefcb8",
					"#a5b3d9",
					"#7d1d85",
					"#c4fd57",
					"#f1ae16",
					"#8fe22a",
					"#ef6e3c",
					"#243eeb",
					"#dd93fd",
					"#3f8473",
					"#e7dbce",
					"#421f79",
					"#7a3d93",
					"#635f6d",
					"#93f2d7",
					"#9b5c2a",
					"#15b9ee",
					"#0f5997",
					"#409188",
					"#911e20",
					"#1350ce",
					"#10e5b1",
					"#fff4d7",
					"#cb2582",
					"#ce00be",
					"#32d5d6",
					"#608572",
					"#c79bc2",
					"#00f87c",
					"#77772a",
					"#6995ba",
					"#fc6b57",
					"#f07815",
					"#8fd883",
					"#060e27",
					"#96e591",
					"#21d52e",
					"#d00043",
					"#b47162",
				];
				position = "bottom";
				displayLegend = false;
		}

		const data = {
			labels: chart.labels,
			datasets: [
				{
					data: chart.data,
					backgroundColor,
					borderColor,
					borderWidth: 1,
				},
			],
		};
		// console.log(data);
		const options = {
			plugins: {
				legend: {
					position,
					display: displayLegend,
				},
				title: {
					display: true,
					text: chart.title,
					padding: {
						top: 15,
						bottom: 20,
					},
				},
			},
		};
		return (
			<div className={styles.card}>
				<Doughnut data={data} options={options} className={styles.chart} plugins={plugins} />
			</div>
		);
	};

	return (
		<>
			{/* LOADING */}
			{/* {loading && <Loader />} */}
			{/* {loading && <Skeleton variant="rectangular" width={400} height={400} />} */}
			{loading && (
				<div className={styles.container}>
					<Skeleton variant="rectangular" height={"auto"} className={styles.card} />
					<Skeleton variant="rectangular" height={"auto"} className={styles.card} />
					{role === Role.Admin && (
						<>
							<Skeleton variant="rectangular" height={"auto"} className={styles.card} />
							<Skeleton variant="rectangular" height={"auto"} className={styles.card} />
						</>
					)}
				</div>
			)}

			{/* NOT LOADING */}
			{!loading && (
				<>
					<div className={styles.container}>
						{allCharts.map((chart) => {
							// if (chart.title === "Roadmap" || chart.title === "Feature Requests")
							return <MyDoughnutChart key={chart.title} chart={chart} />;
						})}
					</div>

					{/* TODO: do something with the feedback button */}
					{/* <NavLink to={{ pathname: "/dashboard" }}>
						<Fab variant="extended" color="primary" sx={{ position: "fixed", bottom: 40, right: 16 }}>
							<Icon path={mdiCommentTextOutline} size={1} />
							&#160;Feedback
						</Fab>
					</NavLink> */}
				</>
			)}
		</>
	);
}
